// TODO: If you make edits to this file you must deal with these ESLint rules
/*eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

import styled from '@emotion/styled';

import { BREAKPOINTS, unit } from '@zego/theme';

import View from '@zego/components/atoms/View';

import AvivaLogo from '@zego/static/svgs/partners/Aviva.svg';
import RSALogo from '@zego/static/svgs/partners/RSA.svg';
import SwissReLogo from '@zego/static/svgs/partners/SwissRe.svg';
import WakamLogo from '@zego/static/svgs/partners/Wakam.svg';

export default function PartnersBranding(): JSX.Element {
  return (
    <PartnerLogosContainer>
      <PartnerLogo
        css={{
          height: unit(7),
          marginTop: unit(2),
          order: 1,
          [BREAKPOINTS.medium]: {
            height: unit(5),
            marginRight: unit(1.5),
          },
          [BREAKPOINTS.normal]: {
            marginRight: unit(3.5),
          },
        }}
        alt="Aviva Logo"
        src={AvivaLogo}
      />
      <PartnerLogo
        css={{
          height: unit(5),
          marginTop: '26px',
          order: 3,
          [BREAKPOINTS.medium]: {
            height: unit(3.5),
            marginRight: unit(1.5),
            marginTop: unit(3.5),
            order: 2,
          },
          [BREAKPOINTS.normal]: {
            marginRight: unit(3.5),
          },
        }}
        alt="RSA Logo"
        src={RSALogo}
      />
      <PartnerLogo
        css={{
          height: unit(4.5),
          marginTop: unit(5),
          order: 4,
          [BREAKPOINTS.medium]: {
            height: unit(3),
            marginTop: '38px',
            marginRight: unit(1.5),
            order: 3,
          },
          [BREAKPOINTS.normal]: {
            height: unit(3.5),
            marginTop: '35px',
            marginRight: unit(3.5),
          },
        }}
        alt="SwissRe Logo"
        src={SwissReLogo}
      />
      <PartnerLogo
        css={{
          height: unit(4),
          marginTop: unit(5),
          order: 2,
          [BREAKPOINTS.medium]: {
            height: '18px',
            marginTop: '38px',
            order: 4,
          },
          [BREAKPOINTS.normal]: {
            height: unit(3),
            marginTop: '34px',
          },
        }}
        alt="Wakam Logo"
        src={WakamLogo}
      />
    </PartnerLogosContainer>
  );
}
const PartnerLogosContainer = styled(View)({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'flex-start',
  width: '100%',
  justifyContent: 'flex-start',
});

const PartnerLogo = styled.img({
  marginRight: 0,
  flex: '50%',
  [BREAKPOINTS.medium]: {
    flex: 'revert',
  },
});
